import { Helmet } from 'react-helmet-async';

export default function Seo({
                                title,
                                description,
                                image = '/og-image.jpg',
                                imageAlt = 'Johannsen IT Solutions – Webdesign für Tierdienstleister',
                                noindex = false,
                                keywords,
                                canonical,
                                siteName = 'Johannsen IT Solutions',
                                type = 'website',
                                schema = [],
                            }) {
    const origin =
        typeof window !== 'undefined'
            ? window.location.origin
            : 'https://johannsen-its.de';

    const pathname =
        typeof window !== 'undefined'
            ? window.location.pathname
            : '/';

    const url = `${origin}${pathname}`;
    const canonicalHref = canonical || url;

    const defaultTitle = 'Webdesign für Tierdienstleister | Johannsen IT Solutions';
    const defaultDescription =
        'Webdesign für Tierdienstleister, Hundefriseure, Hundeschulen, Hundezüchter und Tierbetriebe. Moderne Websites mit Fokus auf Vertrauen, Sichtbarkeit und Kundenanfragen.';

    const finalTitle = title || defaultTitle;
    const finalDescription = description || defaultDescription;

    const imageAbs = image.startsWith('http') ? image : `${origin}${image}`;
    const robots = noindex ? 'noindex,follow' : 'index,follow';
    const keywordContent = Array.isArray(keywords) ? keywords.join(', ') : keywords;

    const organizationJsonLd = {
        '@context': 'https://schema.org',
        '@type': 'ProfessionalService',
        '@id': `${origin}/#business`,
        name: 'Johannsen IT Solutions',
        url: origin,
        logo: `${origin}/assets/LogoJITS.svg`,
        image: imageAbs,
        description:
            'Webdesign und Webentwicklung für Tierdienstleister, Hundefriseure, Hundeschulen, Hundezüchter und lokale Unternehmen.',
        areaServed: {
            '@type': 'Country',
            name: 'Deutschland',
        },
        address: {
            '@type': 'PostalAddress',
            addressLocality: 'Rhauderfehn',
            addressCountry: 'DE',
        },
        email: 'kontakt@johannsen-its.de',
        telephone: '+49 151 17806720',
        founder: {
            '@type': 'Person',
            name: 'Thorben Johannsen',
        },
    };

    const websiteJsonLd = {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        '@id': `${origin}/#website`,
        name: siteName,
        url: origin,
        inLanguage: 'de-DE',
        publisher: {
            '@id': `${origin}/#business`,
        },
    };

    const allSchema = [organizationJsonLd, websiteJsonLd, ...schema];

    return (
        <Helmet prioritizeSeoTags>
            <title>{finalTitle}</title>
            <meta name="description" content={finalDescription} />
            {keywordContent && <meta name="keywords" content={keywordContent} />}
            <meta name="robots" content={robots} />
            <link rel="canonical" href={canonicalHref} />

            <meta property="og:type" content={type} />
            <meta property="og:locale" content="de_DE" />
            <meta property="og:site_name" content={siteName} />
            <meta property="og:title" content={finalTitle} />
            <meta property="og:description" content={finalDescription} />
            <meta property="og:url" content={canonicalHref} />
            <meta property="og:image" content={imageAbs} />
            <meta property="og:image:secure_url" content={imageAbs} />
            <meta property="og:image:alt" content={imageAlt} />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={finalTitle} />
            <meta name="twitter:description" content={finalDescription} />
            <meta name="twitter:image" content={imageAbs} />
            <meta name="twitter:image:alt" content={imageAlt} />

            {allSchema.map((item, index) => (
                <script
                    key={index}
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{ __html: JSON.stringify(item) }}
                />
            ))}
        </Helmet>
    );
}